import { Pipe, PipeTransform } from '@angular/core';
import { get } from 'lodash';//use this to get value from nest object

@Pipe({
  name: 'rdsFilterOptions'
})
export class RdsFilterOptionsPipe implements PipeTransform {

  transform(lstItems: any[], fieldName:string, options: string): any {
    return lstItems.filter(item => this.validateData(item, fieldName, options));
  }


  validateData(item:any, fieldName:string, options:string){
    if(!options || !options.length) return false;
 
    let lstOpts = options.indexOf(';') > -1 ? options.split(';'): [options];
    

    let itemVal = get(item, fieldName);
    itemVal = !itemVal ? '' : itemVal.toLowerCase(); 

    let isValid = false;
    lstOpts.forEach(opt => { 

      if(opt.toLowerCase() === itemVal){
        isValid = true;
      }
    });

    return isValid;
  }

}
